/* Handle Tab Indexes on Flickity Carousel */
(function() {
  // Constants
  const currentScript = document.currentScript;
  const parentSelector = currentScript.dataset.parentSelector;
  const shouldWaitForDOMContent = `${currentScript.dataset.waitForDomContent}` === 'true';

  // Helper Functions
  function handleContainerTabIndex() {
    const container = document.querySelector(`${parentSelector} flickity-carousel.flickity-carousel--custom > [data-carousel]`);
    container.setAttribute('tabindex', '-1');
  }

  function handleScrollButtonTabIndex() {
    const scrollButtons = Array.from(document.querySelectorAll(`${parentSelector} flickity-carousel.flickity-carousel--custom button.flickity-button`));
    scrollButtons.forEach(function(button) {
      button.setAttribute('tabindex', '-1');
    })
  }

  function init() {
    handleContainerTabIndex();
    handleScrollButtonTabIndex();
  }

  // Main
  if (shouldWaitForDOMContent) {
    document.addEventListener('DOMContentLoaded', function() {
      // Hack to handle any delays in rendering flickity-carousel
      setTimeout(function() {
        init();
      }, 500);
    });
  } else {
    init();
  }
})();